<ng-template #registrationButton>
  <button (click)="company = _company; canceled.emit()" mat-button>Cancel</button>
  <button (click)="submitCompanyRequest()" [disabled]="companyForm.invalid || saving " color="primary" mat-button>
    <i *ngIf="saving" class="fas fa-spinner fa-spin"></i>
    <ng-container *ngIf="!saving">Submit request</ng-container>
  </button>
</ng-template>


<form [formGroup]="companyForm" fxLayout="row wrap" fxLayoutAlign="space-between">

  <div class="mat-error" *ngIf="generalError">
    {{generalError?.message}}
  </div>

  <mat-form-field fxFlex="45">
    <mat-label>Name </mat-label>
    <input formControlName="companyName" matInput type="text" name="companyName">
    <mat-error
      *ngIf="companyForm.controls.companyName?.errors?.companyName && !companyForm.controls.companyName?.errors?.required">
      Please enter a valid name
    </mat-error>
    <mat-error *ngIf="companyForm.controls.companyName?.errors?.required">
      Field <strong>required</strong>
    </mat-error>
  </mat-form-field>

  <mat-form-field fxFlex="45">
    <mat-label>Email </mat-label>
    <input formControlName="companyEmail" matInput type="email" name="companyEmail">
    <mat-error
      *ngIf="companyForm.controls.companyEmail?.errors?.pattern && !companyForm.controls.companyEmail?.errors?.required">
      Please enter a valid email address
    </mat-error>
    <mat-error *ngIf="companyForm.controls.companyEmail?.errors?.required">
      Field <strong>required</strong>
    </mat-error>
  </mat-form-field>

  <mat-form-field fxFlex="45">
    <mat-label>Address </mat-label>
    <input ngx-gp-autocomplete formControlName="companyAddress" matInput type="text" name="companyAddress">
    <mat-error *ngIf="companyForm.controls.companyAddress?.errors?.required">
      Field <strong>required</strong>
    </mat-error>
  </mat-form-field>

  <mat-form-field fxFlex="45">
    <mat-label>Contact Email 1</mat-label>
    <input formControlName="contact1email" matInput type="email" name="contact1email">
    <mat-error
      *ngIf="companyForm.controls.contact1email?.errors?.pattern && !companyForm.controls.contact1email?.errors?.required">
      Please enter a valid email address
    </mat-error>
  </mat-form-field>

  <mat-form-field fxFlex="45">
    <mat-label>Contact Email 2</mat-label>
    <input formControlName="contact2email" matInput type="email" name="contact2email">
    <mat-error
      *ngIf="companyForm.controls.contact2email?.errors?.pattern && !companyForm.controls.contact2email?.errors?.required">
      Please enter a valid email address
    </mat-error>
  </mat-form-field>

  <mat-form-field fxFlex="45">
    <mat-label>Contact Phone 1</mat-label>
    <input formControlName="contact1phone" matInput type="tel" name="contact1phone" [mask]="'+00 000 0*'"
      [dropSpecialCharacters]="false">
    <mat-error *ngIf="companyForm.controls.contact1phone?.errors?.pattern">
      Please enter a valid phone number
    </mat-error>
  </mat-form-field>

  <mat-form-field fxFlex="45">
    <mat-label>Contact Phone 2</mat-label>
    <input formControlName="contact2phone" matInput type="tel" name="contact2phone" [mask]="'+00 000 0*'"
      [dropSpecialCharacters]="false">
    <mat-error *ngIf="companyForm.controls.contact2phone?.errors?.pattern">
      Please enter a valid phone number
    </mat-error>
  </mat-form-field>

  <mat-form-field fxFlex="45">
    <mat-label>Contact Role 1</mat-label>
    <input formControlName="contact1role" matInput type="text" name="contact1role">
  </mat-form-field>

  <mat-form-field fxFlex="45">
    <mat-label>Contact Role 2</mat-label>
    <input formControlName="contact2role" matInput type="text" name="contact2role">
  </mat-form-field>

  <re-captcha *ngIf="isRegistrationRequest" fxFlex="45" formControlName="recaptchaReactive" name="recaptchaReactive"
    size="normal" [siteKey]="recaptchaKey"></re-captcha>

  <div fxFlex="100" fxLayout="row" fxLayoutAlign="end">
    <ng-container *ngIf="!isRegistrationRequest else registrationButton">
      <button (click)="company = _company; canceled.emit()" mat-button>Cancel</button>
      <button (click)="saveCompany()" [disabled]="companyForm.invalid || saving " color="primary" mat-button>
        <i *ngIf="saving" class="fas fa-spinner fa-spin"></i>
        <ng-container *ngIf="!saving">Save</ng-container>
      </button>
    </ng-container>
  </div>

</form>